// Error codes emitted by the LI.FI API
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["DefaultError"] = 1000] = "DefaultError";
    ErrorCode[ErrorCode["FailedToBuildTransactionError"] = 1001] = "FailedToBuildTransactionError";
    ErrorCode[ErrorCode["NoQuoteError"] = 1002] = "NoQuoteError";
    ErrorCode[ErrorCode["NotFoundError"] = 1003] = "NotFoundError";
    ErrorCode[ErrorCode["NotProcessableError"] = 1004] = "NotProcessableError";
    ErrorCode[ErrorCode["RateLimitError"] = 1005] = "RateLimitError";
    ErrorCode[ErrorCode["ServerError"] = 1006] = "ServerError";
    ErrorCode[ErrorCode["SlippageError"] = 1007] = "SlippageError";
    ErrorCode[ErrorCode["ThirdPartyError"] = 1008] = "ThirdPartyError";
    ErrorCode[ErrorCode["TimeoutError"] = 1009] = "TimeoutError";
    ErrorCode[ErrorCode["UnauthorizedError"] = 1010] = "UnauthorizedError";
    ErrorCode[ErrorCode["ValidationError"] = 1011] = "ValidationError";
})(ErrorCode || (ErrorCode = {}));
